import styled, { css } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { fontWeight, radius, color, spacing, variant, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var variantKindStyles = variant({
  prop: "variant",
  compoundProp: "kind",
  variants: {
    default: {
      color: themeMode({
        light: "neutral.900",
        dark: "neutral.50"
      }),
      base: {
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.700"
        })
      },
      subtle: {
        backgroundColor: themeMode({
          light: palette("neutral.200", 0.24),
          dark: palette("neutral.700", 0.48)
        })
      }
    },
    inverted: {
      color: themeMode({
        light: "neutral.50",
        dark: "neutral.900"
      }),
      base: {
        backgroundColor: themeMode({
          light: "neutral.1000",
          dark: "neutral.0"
        })
      },
      subtle: {
        color: "neutral.900",
        backgroundColor: themeMode({
          light: palette("neutral.1000", 0.24),
          dark: palette("neutral.0", 0.48)
        })
      }
    },
    primary: {
      base: {
        color: "neutral.900",
        backgroundColor: "primary.500"
      },
      subtle: {
        color: themeMode({
          light: "primary.700",
          dark: "primary.300"
        }),
        backgroundColor: palette("primary.500", 0.24)
      }
    },
    secondary: {
      base: {
        color: "neutral.50",
        backgroundColor: "secondary.500"
      },
      subtle: {
        color: "secondary.300",
        backgroundColor: palette("secondary.500", 0.24)
      }
    },
    danger: {
      base: {
        color: "neutral.50",
        backgroundColor: "danger.500"
      },
      subtle: {
        color: "danger.300",
        backgroundColor: palette("danger.500", 0.24)
      }
    },
    warning: {
      base: {
        color: "neutral.900",
        backgroundColor: "warning.500"
      },
      subtle: {
        color: themeMode({
          light: "warning.700",
          dark: "warning.300"
        }),
        backgroundColor: palette("warning.500", 0.24)
      }
    },
    success: {
      base: {
        color: "neutral.50",
        backgroundColor: "success.500"
      },
      subtle: {
        color: themeMode({
          light: "success.700",
          dark: "success.300"
        }),
        backgroundColor: palette("success.500", 0.24)
      }
    },
    bronze: {
      base: {
        color: "neutral.50",
        backgroundColor: "bronze.500"
      },
      subtle: {
        color: themeMode({
          light: "bronze.700",
          dark: "bronze.300"
        }),
        backgroundColor: palette("bronze.500", 0.24)
      }
    },
    silver: {
      base: {
        color: "neutral.50",
        backgroundColor: "silver.500"
      },
      subtle: {
        color: themeMode({
          light: "silver.700",
          dark: "silver.300"
        }),
        backgroundColor: palette("silver.500", 0.24)
      }
    },
    gold: {
      base: {
        color: "neutral.50",
        backgroundColor: "gold.500"
      },
      subtle: {
        color: themeMode({
          light: "gold.700",
          dark: "gold.300"
        }),
        backgroundColor: palette("gold.500", 0.24)
      }
    },
    platinum: {
      base: {
        color: "neutral.900",
        background: "linear-gradient(\n                    315deg,\n                    #adb7bf 0%,\n                    #dfe3e9 50%,\n                    #6c7782 100%\n                )"
      },
      subtle: {
        color: themeMode({
          light: "platinum.600",
          dark: "platinum.50"
        }),
        background: "linear-gradient(\n                    315deg,\n                    #adb7bf66 0%,\n                    #dfe3e966 50%,\n                    #6c778266 100%\n                )"
      }
    }
  }
});
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      textTransform: "uppercase",
      height: "16px"
    },
    md: {
      height: "24px"
    }
  }
});
var contentSizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      py: "0",
      px: "xs",
      fontSize: "xs",
      lineHeight: "16px",
      svg: {
        marginRight: "xxs"
      }
    },
    md: {
      py: "0",
      px: "xs",
      fontSize: "sm",
      lineHeight: 1,
      svg: {
        marginRight: "xxs"
      }
    }
  }
});
var Badge = styled(Box).withConfig({
  componentId: "xpo93y-0"
})(["display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:center;min-width:auto;text-align:center;white-space:nowrap;user-select:none;font-weight:", ";border-radius:", ";cursor:", ";", ";", ";", ";"], fontWeight("bold"), function (_ref) {
  var isRounded = _ref.isRounded;
  return isRounded ? radius("round") : radius("base");
}, function (_ref2) {
  var onClick = _ref2.onClick;
  return onClick ? "pointer" : "inherit";
}, variantKindStyles, sizeStyles, function (_ref3) {
  var isPinned = _ref3.isPinned;
  return isPinned && css(["box-shadow:0px 0px 0px 2px ", ";"], color("background.base"));
});
styled(Box).withConfig({
  componentId: "xpo93y-1"
})([""]);
var Content = styled(Box).attrs(function () {
  return {
    as: "span"
  };
}).withConfig({
  componentId: "xpo93y-2"
})(["display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:center;", ";"], contentSizeStyles);
var Dot = styled(Box).withConfig({
  componentId: "xpo93y-3"
})(["width:", ";height:", ";", ";border-radius:", ";", ";"], spacing("sm"), spacing("sm"), variantKindStyles, radius("round"), function (_ref4) {
  var isPinned = _ref4.isPinned;
  return isPinned && css(["box-shadow:0px 0px 0px 2px ", ";"], color("background.base"));
});
export { Badge, Content, Dot };